var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true },
        },
      ],
      staticClass: "hx-table-result",
    },
    [
      _c(
        "div",
        { staticClass: "action clearfix spacing-md" },
        [_vm._t("action")],
        2
      ),
      _vm._t("default"),
      _c(
        "div",
        { staticClass: "content clearfix spacing-md" },
        [_vm._t("content")],
        2
      ),
      _c(
        "div",
        { staticClass: "footer clearfix spacing-md" },
        [
          _c(
            "el-row",
            { attrs: { type: "flex", justify: "end" } },
            [
              _vm.showPagerOnOnePage && Number(_vm.pageInfo.total)
                ? _c("el-pagination", {
                    staticClass: "fr mgt10 align-right",
                    attrs: {
                      background: "",
                      "current-page": _vm.pageInfo.pageIndex,
                      "page-size": _vm.pageInfo.pageSize,
                      total: _vm.pageInfo.total,
                      layout:
                        (_vm.pageTotal ? "total," : "") +
                        "sizes,prev,pager,next,jumper",
                      "page-sizes": _vm.pageSizes,
                    },
                    on: {
                      "size-change": _vm.pageSizeChange,
                      "current-change": _vm.pageCurrentChange,
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
          _vm._t("footer"),
        ],
        2
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }